import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ffa92f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "availableAmount" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("元です。他の荷物の発送に影響が出ないよう、早めのチャージをおすすめします。 ")
const _hoisted_4 = { class: "footer text-rt" }

import CommonDialog from '@/components/common/CommonDialog.vue'
import { onMounted, ref } from 'vue'
import { t } from '@/plugins/i18n'
import { useRouter } from 'vue-router'
import { useRtfix } from '@/store'
import { request } from '@/config/request/interceptors'
import { PkgStandDialogVO } from '@/service/settlement'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const visible = ref(false)
const bill = ref<PkgStandDialogVO>()
// 充值
const recharge = () => {
  router.push(useRtfix('Recharge'))
}
// 查看资金流水
const check = () => {
  router.push(useRtfix('StoreFund', { query: { fundFlowType: 6, bizContentCustomer: '包裹滞留费', fundTab: 2 } }))
}

onMounted(async () => {
  const res = await request.settlement.bill.notifyPkgStandDialog()
  console.log(res, 'notifyPkgStandDialog')
  visible.value = (res.success && res.data?.show) ?? false
  bill.value = res.data
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(CommonDialog, {
    "z-index": "3003",
    visible: visible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    "show-close": false,
    width: 500,
    onOk: recharge,
    onCancel: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false)),
    title: _unref(t)('包裹滞留费账单已生成'),
    footer: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(" 先月の荷物滞留料金の請求書が作成されました。合計で" + _toDisplayString(bill.value?.changeAmount ?? '') + "元が引き落とされ、現在のアカウント残高は", 1),
        _createElementVNode("span", _hoisted_2, _toDisplayString(bill.value?.availableAmount ?? ''), 1),
        _hoisted_3
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          class: "footer-btn",
          onClick: check
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('查看资金流水')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "footer-btn",
          type: "primary",
          onClick: recharge
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('充值')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})